export interface Pointer {
    x: number;
    y: number;
}

export interface ScrollValue {
    left: number;
    top: number;
}

export interface ScrollTarget {
    clientHeight: number;
    clientWidth: number;
    scrollHeight: number;
    scrollLeft: number;
    scrollWidth: number;
    scrollTop: number;
    scrollTo: (options: ScrollToOptions) => void;
}
